var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHkIcLike(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Option-CardSystem-ShowOption-Copy",
    transform: "translate(-602.000000, -877.000000)",
    stroke: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keyboard-Indication",
    transform: "translate(520.000000, 877.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Like",
    transform: "translate(82.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4-Copy",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12 L20,12 L20,14 L12,14 L12,17 L5,13 L12,9 L12,12 Z",
    id: "Combined-Shape",
    fill: "#333333",
    transform: "translate(12.500000, 13.000000) scale(-1, 1) translate(-12.500000, -13.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHkIcLike);
export default __webpack_public_path__ + "static/media/hkIcLike.645128254c2d9a51c299fad3798288c2.svg";
export { ForwardRef as ReactComponent };